import React, { useState } from 'react';
import styled from 'styled-components';
import { LuBell } from 'react-icons/lu';
import { Modal, ModalTitle, ModalBody, ModalFooter } from './Modal';

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
`;

const IconWrap = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #eff6ff;
  color: #1e40af;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled(ModalTitle)`
  margin: 0;
  flex: 1;
  line-height: 1.25;
`;

const Message = styled.p`
  margin: 0;
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.5;
  font-size: 14px;
`;

const PrimaryButton = styled.button`
  background: linear-gradient(135deg, #1e3a8a 0%, rgb(19, 85, 154) 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

const SecondaryButton = styled.button`
  background: transparent;
  color: ${props => props.theme.colors.textSecondary};
  border: 1px solid ${props => props.theme.colors.borderLight || '#e2e8f0'};
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f8fafc;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

const PushOptInModal = ({ isOpen, onAccept, onDismiss }) => {
  const [busy, setBusy] = useState(false);

  const handleAccept = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onAccept?.();
    } finally {
      setBusy(false);
    }
  };

  const handleDismiss = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onDismiss?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleDismiss}
      closeOnOverlayClick={false}
      showCloseButton={!busy}
    >
      <HeaderRow>
        <IconWrap>
          <LuBell size={24} />
        </IconWrap>
        <Title>Receber notificações?</Title>
      </HeaderRow>
      <ModalBody>
        <Message>
          Podemos avisar você neste navegador sobre lembretes e novidades do portal.
          Você pode ativar ou desativar depois em Perfil.
        </Message>
      </ModalBody>
      <ModalFooter>
        <SecondaryButton type="button" onClick={handleDismiss} disabled={busy}>
          Agora não
        </SecondaryButton>
        <PrimaryButton type="button" onClick={handleAccept} disabled={busy}>
          {busy ? 'Ativando…' : 'Quero receber'}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};

export default PushOptInModal;
